// Trace APP Authentication Action Types
export const SET_AUTH_ERROR = 'SET_AUTH_ERROR'

// Side Panel Reducer Action Types
export const SET_IS_SIDE_PANEL_OPEN = 'SET_IS_SIDE_PANEL_OPEN'
export const SET_SELECTED_TAB = 'SET_SELECTED_TAB'